import { CdkAccordionItem } from '@angular/cdk/accordion';
import { InjectionToken } from '@angular/core';

export interface AccordionItemBase extends CdkAccordionItem {
  getIndex: () => number | undefined;
}

export const APP_ACCORDION_ITEM = new InjectionToken<AccordionItemBase>('APP_ACCORDION_ITEM');
